/**
 * Module-level flag bridging UploadContext and useSessionTimeout without
 * coupling provider order. While uploads are in flight the CJIS inactivity
 * timeout is paused (same precedent as audio playback); because the pause
 * never resets the inactivity clock, logout fires on the first tick after
 * the queue drains — drain-then-logout, never mid-transfer.
 */
let active = false;

export function setUploadActive(value: boolean): void {
  active = value;
}

export function isUploadActive(): boolean {
  return active;
}
